import { render, staticRenderFns } from "./PeopleReportScreen.vue?vue&type=template&id=c3d52bea"
import script from "./PeopleReportScreen.vue?vue&type=script&lang=js"
export * from "./PeopleReportScreen.vue?vue&type=script&lang=js"
import style0 from "./PeopleReportScreen.vue?vue&type=style&index=0&id=c3d52bea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports